import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CallToAction from '../CallToAction';

const HeroStyles = styled.section`
  max-width: 100vw;
  height: 600px;
  background: #ecf0f1;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4));
  background-position: top;
  background-size: cover;
  color: white;
  .flex {
    display: flex;
    align-items: center;
    align-content: center;
  }
  .container {
    height: 100%;
  }
  .content {
    max-width: 90%;
  }
  h2 {
    text-transform: uppercase;
    color: white;
    padding-bottom: 30px;
    margin: 0;
    letter-spacing: 0.0625rem;
    font-size: 20px;
    font-weight: 600;
  }
  p {
    margin: 0;
    font-size: 46px;
    font-weight: 700;
    color: white;
    padding-bottom: 30px;
    line-height: 65px;
  }
  @media only screen and (max-width: 500px) {
    h2 {
      font-size: 14px;
    }
    p {
      font-size: 32px;
      line-height: 51px;
    }
  }
`;

export default function Hero({ topline, tagline, buttonText, image }) {
  return (
    <HeroStyles
      style={{
        background: `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${image}')`,
        backgroundPosition: 'top',
        backgroundSize: 'cover',
      }}
    >
      <div className="container flex">
        <div className="content">
          {topline ? <h2>{topline}</h2> : ''}
          {tagline ? <p>{tagline}</p> : ''}
          {buttonText ? (
            <Link to="/contact">
              <CallToAction>{buttonText}</CallToAction>
            </Link>
          ) : (
            ''
          )}
        </div>
      </div>
    </HeroStyles>
  );
}

Hero.propTypes = {
  topline: PropTypes.string,
  tagline: PropTypes.string,
  buttonText: PropTypes.string,
  image: PropTypes.string.isRequired,
};
